import { useAuth } from "../../contexts/AuthContext";
import OnboardingTour, { OnboardingTourTrigger } from "../../components/OnboardingTour";
import StripeConnectBanner from "../../components/StripeConnectBanner";

const TOUR_ROLES = ["organizer", "exhibitor", "venue_owner", "provider"];

export default function DashboardShell({ title, subtitle, actions, children }) {
  const { user } = useAuth();
  const showTour = user && TOUR_ROLES.includes(user.role);
  return (
    <div className="bg-cream-50 min-h-[calc(100vh-4rem)]">
      {showTour && <OnboardingTour role={user.role} />}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-10">
          <div>
            <p className="text-label text-muted-foreground mb-2" data-testid="dashboard-role">
              Espace {user?.role?.replace("_", " ")}
            </p>
            <h1 className="font-heading font-light tracking-editorial text-3xl sm:text-4xl text-ink">
              {title}
            </h1>
            {subtitle && <p className="text-muted-foreground mt-2">{subtitle}</p>}
            {showTour && (
              <div className="mt-3">
                <OnboardingTourTrigger role={user.role} />
              </div>
            )}
          </div>
          {actions && <div className="flex gap-2">{actions}</div>}
        </div>
        <StripeConnectBanner />
        {children}
      </div>
    </div>
  );
}

export function StatCard({ label, value, accent }) {
  return (
    <div className="bg-white border border-ink/10 rounded-md p-5">
      <p className="text-label text-muted-foreground mb-2">{label}</p>
      <p className={`font-heading font-black text-3xl tracking-tight ${accent ? "text-accent" : "text-ink"}`}>
        {value}
      </p>
    </div>
  );
}
